import { SubmitUserSettingsRequest, UserSettingsRequest, UserSetting } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useClientData } from '@/providers/ClientData.provider';
import vopayApi from '@/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

export const DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY = 'roll-up-balance';
const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostSubmitUserSettings() {
    const [, setDataFetchingInfo] = useDataFetchIndicator();
    const { response } = useClientData();
    const source = axios.CancelToken.source();

    const [userSettings, setUserSettings] = useState<UserSetting>({
      timezone: 'UTC',
      SubAccountBalanceDisplay: DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY,
    });

    const getUserSettings = async (requestParams: UserSettingsRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');
        const res = await api.fetchUserSettings(requestParams, source);
        setUserSettings(
          res.Settings
            ? res.Settings
            : { timezone: 'UTC', SubAccountBalanceDisplay: DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY },
        );
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      if (response.Success && response.JWT && response.LoginUserName) {
        getUserSettings({
          EmailAddress: response.LoginUserName,
        });
      }
    }, [response]);

    const submitUserSettings = async (requestParams: SubmitUserSettingsRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');
        const res = await api.postSubmitUserSettings(requestParams, source);
        // res.Settings = null;
        setUserSettings({
          timezone: res.Settings.timezone,
          SubAccountBalanceDisplay: res.Settings.SubAccountBalanceDisplay,
        });
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      userSettings,
      getUserSettings,
      submitUserSettings,
    };
  };
});
export default hook({});
